import axios from 'axios';
// The login action passes vuex commit helper that we will use to trigger mutations.
export default {
  async getRencanaBelanja({ commit }, params) {
    try {
      const response = await axios.get(
        'rencanabelanja/getRencanabelanja?pagenumber=' + params.page
      );

      commit('GET_RB_PAGE', response.data.data.items);
      commit('GET_TOTAL_DATA', response.data.data.total);

      return response;
    } catch (e) {
      return e;
    }
  },
  async createRencanaBelanja({ commit }, params) {
    try {
      const response = await axios.post(
        'rencanabelanja/insertRencanaBelanja',
        params
      );

      return response;
    } catch (e) {
      return e;
    }
  },
};
